import React from 'react'

import classNames from 'classnames'

import './CampaignProgress.scss'

const getColor = (value: number) => (value < 40 ? 'red' : value < 80 ? 'orange' : 'green')

type CampaignProgressProps = {
  value: number
  color?: boolean
  height?: number | string
  width?: number | string
  children?: React.ReactNode
}

const CampaignProgress = ({ color = true, children, height = 5, width = 60, value }: CampaignProgressProps) => {
  const barWrapperClassName = classNames(
    'campaign-progress__bar-wrapper',
    color && `campaign-progress__bar-wrapper--${getColor(value)}`,
  )

  const barClassName = classNames('campaign-progress__bar', color && `campaign-progress__bar--${getColor(value)}`)

  return (
    <div className="campaign-progress" style={{ width }}>
      <div className="campaign-progress__label">{children || `${value}%`}</div>
      <div className={barWrapperClassName} style={{ height }}>
        <div className={barClassName} style={{ width: `${value}%` }} />
      </div>
    </div>
  )
}

export default CampaignProgress
